export default "__VITE_ASSET__87aa24d9__"